<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            LA CONSTRUCCIÓN <br>
            DE LA TRADICIÓN <br>
            <span class="fontMS300">
                ACUARELAS COSTUMBRISTAS<br>
                DEL ÁLBUM PRAETORIA<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio21/construccion-tradicion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio21/construccion-tradicion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio21/construccion-tradicion">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio21/tradicion_001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    LA BIBLIOTECA NACIONAL DEL PERÚ CONSERVA 24 ACUARELAS Y 14 LITOGRAFÍAS ILUMINADAS PERTENECIENTES AL ÁLBUM PRAETORIA (1871), 
                    EL CUAL FUE ADQUIRIDO EN 1945. ESTA INFORMACIÓN ESTÁ ESCRITA A PLUMA EN LA CARÁTULA. DIFERENTES ESPECIALISTAS ATRIBUYEN LA 
                    AUTORÍA EN ALGUNAS O EL TOTAL DE LAS ACUARELAS AL ARTISTA FRANCISCO FIERRO (LIMA, 1807-1879).
                </p>
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-12">
                                <img class="img1" src="/assets/images/micrositio/micrositio21/tradicion_002.jpg">
                                <p class="fontMS500Italic font-20">
                                    Supuesta fotografía de Pancho Fierro. Ca. 1870.
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 libro">
                                <a href="http://hdl.handle.net/20.500.14428/79567" target="_blank" style="color: black;">
                                    <img class="img2 mt-3" 
                                    src="/assets/images/micrositio/micrositio21/tradicion_003.jpg">
                                    <div class="overlay-img2">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Retrato de Ignacio Merino 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                Portada de El Americano, n. 50
                                                <br>
                                            </span>
                                            París, 10 de marzo de 1873
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <p class="fontMS100 text-justify font-24">
                            Entre las litografías, dos de ellas llevan la firma del pintor Ignacio Merino (Piura, 1817 - París, 1876). 
                            En 1839, ambos artistas peruanos, junto a los litógrafos belgas Dedé y Ducasse, se asocian para la elaboración 
                            de estampas costumbristas, que tenían intensa demanda. Las estampas en el álbum Preatoria responden al consumo 
                            de estampas como recuerdo para viajeros. Después esta producción artística fue tomada como sustento de los 
                            discursos de la élite limeña sobre la identidad peruana basada en lo criollo. 
                            <br><br>
                            La Biblioteca Nacional del Perú preserva dos volúmenes adicionales con ilustraciones costumbristas: el álbum South 
                            American Costumes, de acuarelas y grabados; el Álbum rojo de Gertrude Ginn de grabados y fotos, fechado en 1858 
                            (no está inventariado); y el Álbum Souvenir del Amerique.
                        </p>
                        <div class="row" style="margin-top:20%;">
                            <div class="col-sm-8">
                                <img width="100%" src="/assets/images/micrositio/micrositio21/tradicion_004.jpg">
                            </div>
                            <div class="col-sm-4" style="margin-top: 15%;">
                                <p class="fontMS100 font-22">Álbum
                                    <span class="fontMS100Italic font-22">Praetoria.</span>
                                        Foto: Maribel
                                        Chamorro
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_L">
    <div class="container">
        <div class="col-sm-12">
            <p>
                <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
            </p>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <img class="img-fluid pd-10" src="/assets/images/micrositio/micrositio21/tradicion_005.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p class="text-justify fontMS100 font-24">
                            <span class="fontMS500 font-24">LITOGRAFÍA</span><br>
                            La litografía era un medio de reproducción masiva de la imagen antes de la introducción de la impresión mecánica 
                            a finales del siglo XIX. El diseño es elaborado por el artista sobre una piedra pulida, luego entintada e impresa 
                            al papel por medio de una prensa. Cuando se coloreaba a la acuarela se le denomina litografía iluminada.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-6">
                        <img class="img-fluid pd-10" src="/assets/images/micrositio/micrositio21/tradicion_006.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p class="text-justify fontMS100 font-24">
                            <span class="fontMS500 font-24">ACUARELA</span><br>
                            La acuarela es una técnica de pintura al agua, con una larga historia. Muchas antiguas civilizaciones emplearon pigmentos 
                            suspendidos en agua para decorar sus muros y cerámica. La cultura china empleó la técnica de la aguada desde el siglo IV a.C. 
                            Durante la Edad Media en Europa se creaban y decoraban los manuscritos utilizando acuarelas. No es sino, hasta finales del 
                            siglo XVIII, que la acuarela es reconocida como un procedimiento en sí misma.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA CONSTRUCCIÓN
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    DE LA TRADICIÓN
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p class=" fontMS500 text-white text-center font-24">
                    <br><br>
                    A PRINCIPIOS DEL SIGLO XIX, EL IMAGINARIO NACIONAL DE LAS NUEVAS REPÚBLICAS LATINOAMERICANAS 
                    PRODUJO EXPRESIONES PICTÓRICAS E ICONOGRÁFICAS BASADAS EN SUS SINGULARIDADES.
                </p>
                <p class="fontMS100 text-white text-justify font-24">
                    <br>
                    El costumbrismo peruano fue el primer discurso sobre identidad llevado a cabo por la élite criolla, 
                    poseedora del poder político. Este se basó en la representación de los diferentes tipos de habitantes 
                    de Lima y sus ocupaciones a inicios del siglo XIX, en base a las ilustraciones de los libros de viajeros 
                    europeos que traían el Romanticismo. Tenía primero como referencia la tradición del registro de vestimenta 
                    primero, y luego de costumbres, realizadas por las monarquías colonialistas desde el siglo XVI.
                    <br><br>
                    En las acuarelas se repiten temas y composiciones de Pancho Fierro, lo cual se debe al reciclaje y la copia 
                    que marcaban la pauta del comercio de imágenes populares, no solo a través de la reproducción técnica sino 
                    también por la reproducción a mano de tipos costumbristas para el mercado internacional. La copia de acuarelas 
                    fue una forma generalizada de producción en todo el continente donde el éxito generó una larga lista de imitadores 
                    y competidores.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/80574" target="_blank" style="color: black;">
                                <img width="100%" class="img3_extremo mt-3" 
                                src="/assets/images/micrositio/micrositio21/tradicion_007.jpg">
                                <div class="overlay-img3_extremo">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Corrida de gallos, paseo por las calles de Lima (invitación a la pelea de gallos), Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79343" target="_blank" style="color: black;">
                                <img width="100%" class="img3_extremo mt-3"
                                    src="/assets/images/micrositio/micrositio21/tradicion_010.jpg">
                                <div class="overlay-img3_extremo">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Una verdadera peruana disfrutando del placer de montar a caballo, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 24 x 21 cm
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-4 mt-5">
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79339" target="_blank" style="color: black;">
                                <img width="100%" class="img3_centro mt-3"
                                src="/assets/images/micrositio/micrositio21/tradicion_008.jpg">
                                <div class="overlay-img3_centro">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Un peruano de infantería y su rabona marchando, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 24 x 21 cm
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79261" target="_blank" style="color: black;">
                                <img width="100%" class="img3_centro mt-3"
                                src="/assets/images/micrositio/micrositio21/tradicion_011.jpg">
                                <div class="overlay-img3_centro">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Un esclavo negro levanta a su burro en reposo
                                            <br>
                                            Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79338" target="_blank" style="color: black;">
                                <img width="100%" class="img3_extremo mt-3"
                                src="/assets/images/micrositio/micrositio21/tradicion_009.jpg">
                                <div class="overlay-img3_extremo">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Señora con un Bañador en Chorrillos yendo a darse un baño, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 20.5 cm
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="libro">
                            <a href="http://hdl.handle.net/20.500.14428/79329" target="_blank" style="color: black;">
                                <img width="100%" class="img3_extremo mt-3"
                                src="/assets/images/micrositio/micrositio21/tradicion_012.jpg">
                                <div class="overlay-img3_extremo">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Graves criminales encadenados de a dos encargados del limpiado de Lima
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22 x 21 cm
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top:5%" class="fontMS700 colorPrincipal font-38">
                            ¿QUIÉNES SOMOS?
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-680.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal font-38">
                    CLASIFICACIONES<br>
                    A TRAVÉS DE LA RAZA Y LA<br>
                    ETNICIDAD
                </p>
                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <img width="100%" class="img4"
                                src="/assets/images/micrositio/micrositio21/tradicion_013.jpg">
                        <p class="fontMS100Italic font-22 pd-10">
                            <span class="fontMS500Italic font-22">Cuadro N° 16 Mestizo con Yndia. Producen
                            Cholo.</span> De la serie cuadros del mestizaje del
                            Virrey Amat. Ca. 1776. Óleo sobre madera,
                            97 x 124 cm. La clasificación oficial biológica de la
                            sociedad virreinal quedó registrada en una
                            serie de pinturas solicitadas por el Virrey Amat
                            entre 1760 y 1770. Veinte cuadros reproducían
                            las “castas” en el Perú y su mezclas y
                            combinaciones.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24 fontMS300">
                            <br>
                            LAS PINTURAS DE CASTAS APARECEN EN MÉXICO Y PERÚ A FINES DEL SIGLO XVIII, 
                            Y MÁS QUE UNA DESCRIPCIÓN OBJETIVA, ESTAS PINTURAS ENCIERRAN UN TESTIMONIO 
                            SOBRE LA IDEOLOGÍA SOCIAL DE LA ÉPOCA.
                            <br><br>
                        </p>
                        <p class="fontMS100 font-24">
                            La nueva república, como parte de su herencia colonial, mantuvo esa costumbre de jerarquizar 
                            a sus ciudadanos a partir de la raza. El cual se extendió a lo largo del siglo XIX afianzando 
                            la asociación estrecha entre el color de piel y la condición social del individuo. En las 
                            ilustraciones del álbum Praetoria se reproducen los diversos grupos étnicos de la Lima del 
                            siglo XIX. Contrario al espíritu republicano, las “etiquetas” raciales entre la población 
                            afrodescendiente e indígena perdurarán en el colectivo social hasta la actualidad.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 mt-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79340" target="_blank" style="color: black;">
                            <img class="img5"
                                src="/assets/images/micrositio/micrositio21/tradicion_014.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Cholo con chola (indios) viniendo en burro por la noche, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.3 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79268" target="_blank" style="color: black;">
                            <img class="img5_centro"
                                src="/assets/images/micrositio/micrositio21/tradicion_015.jpg">
                                <div class="overlay-img5_centro">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Una llama cargada para el viaje, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79337" target="_blank" style="color: black;">
                            <img class="img5"
                                src="/assets/images/micrositio/micrositio21/tradicion_016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Negro y negra bailando zamacueca, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 20 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 mt-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79328" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio21/tradicion_017.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Policía rural llevando una negra detrás, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79335" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio21/tradicion_018.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Mulata con flores yendo junto a la procesión, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            DIVERSAS VISIONES
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    SOBRE LA TAPADA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <div class="row">
                    <div class="col-sm-6 mt-5 bottom_cel">
                        <img class="img6"
                            src="/assets/images/micrositio/micrositio21/tradicion_019.jpg">

                        <p class="fontMS100Italic font-22 pd-10 text-white">
                            Juan de la Cruz Cano. Española Criolla de
                            Lima, 1777-1778. Litografía. En: Colección
                            de trajes de España tanto antiguos como
                            modernos, que comprenden todos los de
                            sus dominios.<br>
                            <span class="fontMS100 font-24 text-white pd-10">
                                Recreación de una limeña a partir de
                                imágenes previas del viajero francés
                                Amadée Frézier en 1714 y de un grabado
                                del pintor Julián Dávila en 1774.
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-6 mt-5 c100">
                        <img width="100%" src="/assets/images/micrositio/micrositio21/tradicion_019.jpg">

                        <p class="fontMS100Italic font-22 text-white">
                            <br>
                            Juan de la Cruz Cano. Española Criolla de
                            Lima, 1777-1778. Litografía. En: Colección
                            de trajes de España tanto antiguos como
                            modernos, que comprenden todos los de
                            sus dominios.<br>
                            <span class="fontMS100 font-24 text-white">
                                Recreación de una limeña a partir de
                                imágenes previas del viajero francés
                                Amadée Frézier en 1714 y de un grabado
                                del pintor Julián Dávila en 1774.
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-6 mt5">
                        <p class="font-24 fontMS300 text-white">
                            <br>
                            LA TAPADA SE CONVIERTE EN EL PERSONAJE MÁS EMBLEMÁTICO DE LA LIMA DECIMONÓNICA. 
                            LA FIGURA FEMENINA DE SAYA CON EL ROSTRO CUBIERTO POR UN MANTO FUE MOTIVO DE DIFERENTES 
                            VALORACIONES MORALES A LO LARGO DEL SIGLO XIX.
                            <br><br>
                        </p>
                        <p class="fontMS100 font-24 text-white">
                            Su representación en las acuarelas de Pancho Fierro, y sus copistas, así como en las ilustraciones 
                            de los libros de viajeros, servirán posteriormente para construir una visión romántica ligada a una 
                            idealización de la ciudad y que servirá para abonar en el discurso sobre lo criollo limeño como identidad 
                            nacional a finales del diecinueve. Para cuando se instalaron los estudios fotográficos en Lima hacia mitad 
                            de siglo, la vestimenta de la tapada había sido desplazada por la preferencia hacia la moda francesa. 
                            Sin embargo, la permanencia del discurso costumbrista y su ideal del arquetipo femenino de belleza, lleno 
                            de misterio, sensualidad, delicadeza o coquetería, permitirán la recreación fotográfica de la tapada hasta 
                            entrado el siglo XX, difundiéndose en tarjetas de visita como símbolo de una Lima atemporal, inamovible, 
                            sin cambios.
                        </p>
                    </div>
                </div>
                <div class="row pos-r">
                    <div class="col-sm-6">
                        <div class="libro">
                            <img width="100%" class="img7"
                                    src="\assets\images\micrositio\micrositio21\tradicion_020.jpg">
                        </div>
                    </div>
                    <div class="col-sm-6" style="margin-top:18%">
                        <div class="libro">
                            <img width="100%" class="img-fluid"
                                    src="\assets\images\micrositio\micrositio21\tradicion_021.jpg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <br><br><br><br><br><br><br><br><br><br><br><br>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22 pd-10">
                            Tapada. Acuarela y plumilla, 23.5x16 cm, s.
                            XVIII (ca. 1782-1790). Base de datos del
                            patrimonio bibliográfico del Patrimonio
                            Nacional de España.<br>
                            <span class="fontMS100 font-24 pd-10">
                                Trujillo del Perú recoge los dibujos
                                tomados en la visita que el Obispo
                                Baltasar Jaime Martínez Compañón
                                realizó a su diócesis de Trujillo entre 1782
                                y 1785, visitando territorios de los
                                actuales departamentos de Piura,
                                Lambayeque, Libertad, Cajamarca,
                                Chachapoyas, San Martín y Loreto, pero
                                se cree que los dibujos fueron
                                terminados durante la visita y con
                                posterioridad a ella, hasta 1790.
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic font-22 pd-10">
                            Dos sirvientas de Lima. Nativas que han adoptado la
                            vestimenta española, Litografía a color. Joseph
                            Skinner, The present state of Peru,1805 Hersburgh
                            Libraries, University of Notre Dame.<br>
                            <span class="fontMS100 font-24 pd-10">
                                El inglés Skinner ilustra su periplo por el
                                virreinato del Perú a fines del ciclo colonial
                                con veinte láminas que representan a
                                personajes con trajes típicos o disfrazados
                                para la actuación y la danza.
                            </span>
                        </p>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79336" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_022.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Una tapada va a misa, su ayudante le lleva su manto a la iglesia, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 23 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79334" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_023.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Una señora se pone en aprietos al ponerse su saya y manto, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79267 " target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_024.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Tapada vista desde atrás, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 23 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2 mt-3"></div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79333 " target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_026.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500 text-center">
                                            Ignacio Merino<br>
                                        </span>
                                        <span class="fontMS100">
                                            Señora mitad tapada, 1844
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada a mano
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79266" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_027.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500 text-center">
                                                Ignacio Merino<br>
                                            </span>
                                            <span class="fontMS100">
                                                Señora en la feria, 1844
                                                <br>
                                            </span>
                                            Litografía sobre papel iluminada a mano
                                        </p>
                                    </div>
                        </a>
                    </div>
                    <div class="col-sm-2 mt-3"></div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mt-3 libro">
                        <a href="https://hdl.handle.net/20.500.14428/7056" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_028.jpg">
                                <div class="overlay-img8">
                                    <p class="fontMS100 text-center">
                                        Tapada, 1862. Estudio Courret
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-6 mt-3 libro">
                        <a href="https://hdl.handle.net/20.500.14428/55462" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_029.jpg">
                                <div class="overlay-img8">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Tapadas limeña, 1912
                                            <br>
                                        </span>
                                        Estudio Courret
                                    </p>
                                </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
            </div>
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24 mt-3">
                    «AL PARECER, DESPUÉS DE MÁS DE DOSCIENTOS AÑOS DE SU NACIMIENTO, FIERRO SUFRE DEL MISMO PROBLEMA: SE CONSTRUYÓ SU 
                    DISCURSO CENTRADO MÁS EN EL ENTORNO QUE PINTÓ, OBVIANDO AL PERSONAJE Y A SU PROPIA OBRA ARTÍSTICA E INFLUENCIA. 
                    FIERRO SIGUE SIENDO MULATO Y AUTODIDACTA […] ÉL FUE EL PRIMERO EN PINTAR A LOS PERSONAJES QUE TRANSITARON POR SU CIUDAD, 
                    EL PRIMERO EN RECONOCER SU ENTORNO DESPUÉS DE TRESCIENTOS AÑOS DONDE DOMINÓ LA PINTURA RELIGIOSA Y LOS PERSONAJES JERÁRQUICOS»
                </p>
            </div>
            <div class="col-sm-12 text-right mt-3 mb-3">
                <span class="fontMS500Italic font-24">
                    FERNANDO VILLEGAS. EL COSTUMBRISMO AMERICANO ILUSTRADO:<br>
                    EL CASO PERUANO. IMÁGENES ORIGINALES EN LA ERA DE LA<br>
                    REPRODUCCIÓN TÉCNICA, 2011.
                </span>
            </div>
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA FE MILITANTE
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p class="font-24 fontMS500 fontMS500 text-center">
                    <br>
                    UNA VEZ ESTABLECIDO EL VIRREINATO DEL PERÚ EN 1542, LA EVANGELIZACIÓN DE LA POBLACIÓN FUE INDISPENSABLE PARA SU CONSOLIDACIÓN. 
                    POR ELLO, GRAN CANTIDAD DE MISIONEROS RECORRIERON NUESTRO VASTO TERRITORIO LLEVANDO LA FE CRISTIANA COMO PARTE DEL PODER COLONIAL.
                </p>
                <p class="font-24 text-gris text-justify">
                    Diferentes órdenes religiosas se asentaron a lo largo de las ciudades del extenso virreinato  y, a lo largo de los siglos, la fe 
                    católica se fue consolidando, aunque convivió con prácticas religiosas andinas, generándose el sincretismo religioso. En el caso de Lima, 
                    en los numerosos monasterios y conventos se daba una ferviente vida espiritual. Para el momento de la independencia en 1821, el culto católico 
                    estaba extendido por toda la capital llena de iglesias y campanas, y reglaba muchos aspectos de la vida civil de sus habitantes. En el proceso 
                    de construcción de la república, y por el influjo del movimiento ilustrado, se desarrolló una acción secularizadora para reducir la autoridad 
                    religiosa sobre los nuevos ciudadanos. Esto condujo a redefinir la relación entre lo político, económico y social con lo religioso. Las acuarelas 
                    y grabados del clero limeño formaban parte del intenso comercio de estampas de viajes que tuvieron su auge en el siglo XIX.
                </p>
            
                <div class="row">
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79341" target="_blank" style="color: black;">
                            <img width="100%" height="100%" 
                                    src="\assets\images\micrositio\micrositio21\tradicion_030.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Padre de los Descalzos, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.3 x 21 cm
                                    </p>
                                </div>
                        </a>   
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79331" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_031.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Un monje franciscano, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22 x 20 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79330" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_032.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Padre de San Juan de Dios, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79269" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_034.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Padre de la Buena Muerte, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada a mano
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-4 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79270" target="_blank" style="color: black;">
                            <img width="100%" 
                            src="\assets\images\micrositio\micrositio21\tradicion_035.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Padre de la Merced, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminado
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
            </div>
        </div>
        
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS PREGONES DE LIMA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="text-center fontMS300 colorPrincipal font-40">
                    Y ECONOMÍA AMBULANTE
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                </div>
                <p class="font-24 fontMS500">
                    <br>
                    INICIADA LA REPÚBLICA, LOS NUEVOS GOBERNANTES TUVIERON QUE IMPLEMENTAR URGENTES MEDIDAS PARA RESOLVER LA CRISIS Y DEUDAS, 
                    PRODUCTO DE LAS GUERRAS POR LA INDEPENDENCIA Y LAS GUERRAS CIVILES QUE SE SUCEDIERON HASTA LA MITAD DEL SIGLO DIECINUEVE.
                    <br>
                </p>
                <p class="font-24 fontMS100">
                    <br>
                    El comercio popular, basado en la oferta ambulante de productos y servicios menores, que se desarrollaba desde el virreinato, 
                    ingresó al imaginario colectivo mediante la representación del vendedor ambulante. Al igual que Francisco Fierro, los viajeros 
                    extranjeros que recorrieron Sudamérica dibujaron y pintaron las impresiones sobre mercados y ferias, calles y plazas de Lima, 
                    transitada por panaderos, aguadores, mantequeros, cargadores, bizcocheros, dulceras o fruteras.
                    <br>
                </p>
                <p class="font-24 fontMS100">
                    <br>
                    El escritor Ricardo Palma (Lima, 1833 – 1919) en “Con días y ollas venceremos”, de su obra Tradiciones Peruanas, menciona que, 
                    hacia 1820, los vendedores ofrecían sus productos entonando pregones (frases y cantos) a diferentes horas del día. A inicios del siglo XX, 
                    la europeización de la sociedad hizo que este comercio ambulatorio fuera perdiéndose paulatinamente, a tal punto que Palma declaraba con 
                    pena que «Lima ha ganado en civilización; pero se ha despoetizado, y día por día pierde todo lo que de original y típico hubo en sus costumbres».
                    <br>
                </p>

                <div class="row">
                    <div class="col-sm-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79104" target="_blank" style="color: black;">
                            <img width="100%" src="\assets\images\micrositio\micrositio21\tradicion_036.jpg">
                                <div class="overlay-img13">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">Rosa Mercedes Ayarza<br></span>
                                        <span class="fontMS100">
                                            La chichera, estampa limeña 
                                            <br>
                                        </span>
                                        Editorial La Rosa Hnos. Ca. 1950
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-8">
                        <p class="font-24 text-gris fontMS300 pi-10">
                            <br>
                            Más de un siglo después, inspiradas en la recopilación literaria de esta usanza oral, Rosa Ayarza y Victoria Santa Cruz, 
                            cultoras de la tradición musical, reversionan los pregones continuando con la construcción de nuestra identidad local.
                            <br><br>
                        </p>
                        <div class="row pi-10">
                            <div class="col-sm-8">
                                <div class="row">
                                    <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                                </div>
                                <div class="row">
                                    <tr class="borderT">
                                        <td>
                                            <i class="fas fa-volume-up font-24 p-3"></i>
                                        </td>
                                        <td class="p-3">
                                            <p class="fontMS700 text-justify font-16">
                                                LA CHICHERA
                                                <br>
                                                <span class="fontMS100Italic">Rosa Mercedes Ayarza</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <audio controls controlsList="nodownload">
                                        <source src="/assets/audios/La_chichera_Rosa_Mercedes_Ayarza_sin aplausos.mp3" type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio>
                                    <p>
                                        <br>
                                    </p>
                                </div>
                                <div class="row">
                                    <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                                </div>
                                <br>
                                <div class="row">
                                    <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                                </div>
                                <div class="row">
                                    <tr class="borderT">
                                        <td>
                                            <i class="fas fa-volume-up font-24 p-3"></i>
                                        </td>
                                        <td class="p-3">
                                            <p class="fontMS700 text-justify font-16">
                                                GRITOS DE PREGONEROS
                                                <br>
                                                <span class="fontMS100Italic">Victoria Santa Cruz</span>
                                            </p>
                                        </td>
                                    </tr>
                                    <audio controls controlsList="nodownload">
                                        <source src="/assets/audios/Gritos_de_pregoneros_Victoria_Santacruz.mp3" type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio>
                                    <p>
                                        <br>
                                    </p>
                                </div>
                                <div class="row">
                                    <img width="100%" src="/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_LINEA2.jpg">
                                </div>
                            </div>
                            <div class="col-sm-4"></div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79332" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_037.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Velero, vendedor de sebo, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 20.5 cm
                                    </p>
                                </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79346" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_038.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Aguador o el que lleva agua a las casas, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 21 cm
                                    </p>
                                </div>
                        </a> 
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79345" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_039.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Panadero o el que lleva pan a las casas, Ca. 1845
                                            <br>
                                        </span>
                                        Acuarela sobre papel, 22.5 x 20 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79262" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_040.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Vendedora de chicha caminando dentro de la ciudad, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada, 21 x 20 cm
                                    </p>
                                </div>
                        </a>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col"></div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79263" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_041.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            “Cargador” o carga bultos, tiene un pequeño saco que cuelga de su cabeza, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada
                                    </p>
                                </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79264" target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_042.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            “Mantequero” vendedor de mantequilla o grasa, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminada
                                    </p>
                                </div>
                        </a>
                        
                    </div>
                    <div class="col-sm-3 mt-3 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79265 " target="_blank" style="color: black;">
                            <img width="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_043.jpg">
                                <div class="overlay-img12">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS100">
                                            Chichera, Ca. 1845
                                            <br>
                                        </span>
                                        Litografía sobre papel iluminad
                                    </p>
                                </div>
                        </a>
                        
                    </div>
                    <div class="col"></div>
                </div>  
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            A fines del siglo XIX, a través de la fotografía se registra la pervivencia de oficios 
                            en medio de los cambios urbanos de la época. Aproximadamente, cien años después, el fotógrafo 
                            Roberto Huarcaya realiza la serie “Lima la de ayer, la de mañana” donde retrata en un estudio 
                            a mujeres, hombres y niños que ofrecen mercadería y servicios, aislados de veredas y pistas. 
                            Además, el artista escribe la historia de sus modelos como marco de la foto. El comercio 
                            ambulatorio en la capital del Perú es de gran magnitud y juega un importante rol en la 
                            economía familiar urbana. Se estima en más de 300 mil los vendedores ambulantes en Lima 
                            Metropolitana, de los cuales 70% son mujeres. 
                            <br><br>
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <p class="fontMS500 font-22 text-white">
                                ¿Qué similitudes y diferencias encuentras
                                entre los oficios de las acuarelas y los de las
                                fotografías?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                            
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500 font-22 text-white">
                                ¿A qué personajes de nuestra lima actual te
                                gustaría retratar?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500 font-22 text-white">
                                Te invitamos a crear una biografía de uno de
                                estos personajes. Para ello debes investigar
                                sobre su oficio y sobre su época.
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 mt-3 libro">
                            <a href="http://hdl.handle.net/20.500.14428/79342" target="_blank" style="color: black;">
                                <img class="p-5" width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_044.jpg">
                                    <div class="overlay-img14">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS100">
                                                Heladero y vendedor de fresco. Ca. 1845
                                                <br>
                                            </span>
                                            Acuarela sobre papel, 22 x 21 cm
                                        </p>
                                    </div>
                            </a>
                        </div>
                        <div class="col-sm-4 mt-3">
                            <img class="p-5" width="100%" height="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_045.jpg">
                        </div>
                        <div class="col-sm-4 mt-3">
                            <img class="p-5" width="100%" height="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_046.jpg">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4 mt-3 libro">
                            <a href="http://hdl.handle.net/20.500.14428/79344" target="_blank" style="color: black;">
                                <img class="p-5" width="100%" height="100%"
                                    src="\assets\images\micrositio\micrositio21\tradicion_047.jpg">
                                    <div class="overlay-img14">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS100">
                                                Lechera o vendedora de leche, Ca. 1845
                                                <br>
                                            </span>
                                            Acuarela sobre papel, 22.5 x 21 cm
                                        </p>
                                    </div>
                            </a>
                        </div>
                        <div class="col-sm-4 mt-3">
                            <img class="p-5" width="100%" height="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_048.jpg">
                        </div>
                        <div class="col-sm-4 mt-3">
                            <img class="p-5" width="100%" height="100%"
                            src="\assets\images\micrositio\micrositio21\tradicion_049.jpg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Kusunoki, Ricardo (2017)</span><br>
                    <span class="fontMS100Italic text-gris">
                        Ignacio Merino. Pintor de historia, 200 años. <br>
                    </span>
                    <span class="text-gris">
                        Municipalidad Metropolitana de Lima<br>
                    </span>
                    <a href="https://repositoriodigital.gob.pe/bnp/recursos/15/html/ignacio-merino-pintor-de-historia-200-anos/" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Villegas, Fernando (2011)<br>
                    </span>
                    <span class="fontMS100Italic text-gris">
                        El costumbrismo americano ilustrado. El caso
                        peruano. Imágenes originales en la era de la
                        reproducción técnica.
                    </span>
                    <span class="text-gris">En: Anales del Museo
                        de América, Nº 19, Madrid, pp.7-67.<br></span>
                    <a href="https://www.academia.edu/2040566/El_Costumbrismo_americano_ilustrado_El_caso_peruano_Im%C3%A1genes_originales_en_la_era_de_la_reproducci%C3%B3n_t%C3%A9cnica_Anales_del_Museo_de_Am%C3%A9rica_XIX_2011_Madrid_pp_07_67?auto=download" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Majluf, Natalia (2008)<br></span>
                    <span class="fontMS100Italic text-gris">
                        Pancho Fierro, entre el mito y la historia.
                    </span>
                    <span class="text-gris">
                        En: Tipos del Perú: La Lima criolla de Pancho
                        Fierro, Madrid, El Viso, 2008, pp.17-50.<br>

                    </span>
                    <a href="http://www.esteticas.unam.mx/edartedal/PDF/Queretaro/complets/majluf_libro.pdf"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Guerrero, Miguel Ángel (2018)<br></span>
                    <span class="fontMS100Italic text-gris">Sátira y transgresión: Francisco “Pancho” Fierro, más allá del costumbrismo peruano del siglo XIX. 
                    </span>
                    <span class="text-gris">
                        Tesis. Escuela de Posgrado - Pontificia Universidad Católica del Perú<br>
                    </span>
                    <a href="http://tesis.pucp.edu.pe/repositorio/handle/20.500.12404/12797"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Munive, Manuel (2014)<br></span>
                    <span class="text-gris">Catálogo de la exposición </span>
                    <span class="fontMS100Italic text-gris">El rostro de Lima.
                        La fisonomía como paisaje social.
                    </span>
                    <span class="text-gris">
                        Municipalidad Metropolitana de Lima<br>
                    </span>
                    <a href="https://issuu.com/florezalex/docs/rostros_de_lima_issuu"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Poole, Deborah (2000)<br></span>
                    <span class="fontMS100Italic text-gris">Visión, raza y modernidad: una economía
                        visual del mundo andino en imágenes.
                    </span>
                    <span class="text-gris">Lima:
                        Sur. Casa de Estudios del Socialismo.<br> </span>

                    <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=257160" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->